// 301 redirects that used to be inline <Route> entries in the old App.tsx.
// Served as real server-side 301s by src/routes/$.tsx.
export const INLINE_REDIRECTS: Array<[string, string]> = [
  ["/insurance/hphc-rehab-nj", "/insurance/harvard-pilgrim-rehab-nj"],
  ["/insurance/point32health-rehab-nj", "/insurance/harvard-pilgrim-rehab-nj"],
  ["/insurance/beacon-rehab-nj", "/insurance/carelon-rehab-nj"],
  ["/insurance/uhc-rehab-nj", "/insurance/united-healthcare-rehab-nj"],
  ["/insurance/bcbs-rehab-nj", "/insurance/blue-cross-blue-shield-rehab-nj"],
  ["/insurance/horizon-bcbs-rehab-nj", "/insurance/horizon-blue-cross-blue-shield-nj-rehab"],
  ["/insurance/horizon-nj-health-rehab-nj", "/insurance/horizon-blue-cross-blue-shield-nj-rehab"],
  ["/2024/02/15/the-addictive-nature-why-is-oxycodone-so-addictive", "/oxycodone-addiction-treatment-nj"],
  ["/2024/02/17/exploring-the-link-can-meth-use-lead-to-cancer", "/meth-use-cancer-link-nj"],
  ["/2024/02/19/combining-support-and-independence-iop-with-housing-options", "/iop-with-housing-options-nj"],
  ["/2024/02/16/understanding-vivitrol-duration-and-effectiveness-of-the-shot", "/vivitrol-shot-duration-effectiveness-nj"],
  ["/2024/08/30/how-iop-programs-support-addiction-recovery-without-full-hospitalization", "/how-iop-programs-support-addiction-recovery-nj"],
  ["/privacy-policy", "/privacy-policy"],
  ["/instant-insurance-verification-cherry-hill-nj", "/verify-insurance-60-seconds-nj"],
  ["/2024/02/18/evening-intensive-outpatient-program-balancing-daily-life", "/evening-iop-new-jersey"],
  ["/what-is-zaza", "/what-is-zaza-drug-nj"],
  ["/what-is-valium", "/what-is-valium"],
  ["/what-is-diazepam", "/what-is-valium"],
  ["/is-valium-a-benzo", "/what-is-valium"],
  ["/how-long-does-valium-stay-in-your-system", "/how-long-does-valium-stay-in-your-system-nj"],
  ["/how-long-does-valium-stay-in-system", "/how-long-does-valium-stay-in-your-system-nj"],
  ["/valium-detection-time", "/how-long-does-valium-stay-in-your-system-nj"],
  ["/valium-vs-xanax-nj", "/valium-vs-xanax-nj"],
  ["/valium-vs-xanax", "/valium-vs-xanax-nj"],
  ["/xanax-vs-valium", "/valium-vs-xanax-nj"],
  ["/diazepam-vs-alprazolam", "/valium-vs-xanax-nj"],
  ["/valium-withdrawal-symptoms-timeline-nj", "/valium-withdrawal-symptoms-timeline-nj"],
  ["/valium-withdrawal", "/valium-withdrawal-symptoms-timeline-nj"],
  ["/valium-withdrawal-symptoms", "/valium-withdrawal-symptoms-timeline-nj"],
  ["/diazepam-withdrawal", "/valium-withdrawal-symptoms-timeline-nj"],
  ["/tapering-off-valium-nj", "/tapering-off-valium-nj"],
  ["/tapering-off-valium", "/tapering-off-valium-nj"],
  ["/valium-taper", "/tapering-off-valium-nj"],
  ["/diazepam-taper-schedule", "/tapering-off-valium-nj"],
  ["/alcohol-rehab-new-jersey-guide", "/alcohol-rehab-new-jersey-guide"],
  ["/alcohol-rehab-new-jersey", "/alcohol-rehab-new-jersey-guide"],
  ["/alcohol-rehabilitation-nj", "/alcohol-rehab-new-jersey-guide"],
  ["/addiction-treatment-near-cherry-hill-philadelphia-families", "/addiction-treatment-near-cherry-hill-philadelphia-families"],
  ["/detox-centers-near-me-cherry-hill-nj", "/addiction-treatment-near-cherry-hill-philadelphia-families"],
  ["/methadone-clinics-camden-county-nj", "/methadone-clinics-camden-county-nj"],
  ["/methadone-clinics-camden-nj", "/methadone-clinics-camden-county-nj"],
  ["/methadone-clinic-near-me", "/methadone-clinics-camden-county-nj"],
  ["/methadone-clinics-nj", "/methadone-clinics-camden-county-nj"],
  ["/zaza-tianeptine-withdrawal-timeline-nj", "/zaza-tianeptine-withdrawal-timeline-nj"],
  ["/zaza-withdrawal", "/zaza-tianeptine-withdrawal-timeline-nj"],
  ["/tianeptine-withdrawal", "/zaza-tianeptine-withdrawal-timeline-nj"],
  ["/how-much-does-mat-cost-nj", "/how-much-does-mat-cost-nj"],
  ["/mat-cost", "/how-much-does-mat-cost-nj"],
  ["/suboxone-cost-nj", "/how-much-does-mat-cost-nj"],
  ["/how-much-does-sublocade-cost-nj", "/how-much-does-sublocade-cost-nj"],
  ["/sublocade-cost", "/how-much-does-sublocade-cost-nj"],
  ["/how-much-does-sublocade-cost", "/how-much-does-sublocade-cost-nj"],
  ["/how-long-does-suboxone-stay-in-your-system", "/how-long-does-suboxone-stay-in-your-system-nj"],
  ["/suboxone-detection-time", "/how-long-does-suboxone-stay-in-your-system-nj"],
  ["/suboxone-doctors-near-me", "/suboxone-doctors-near-me-south-jersey-nj"],
  ["/suboxone-clinic-near-me", "/suboxone-doctors-near-me-south-jersey-nj"],
  ["/buprenorphine-doctor-nj", "/suboxone-doctors-near-me-south-jersey-nj"],
  ["/outpatient-rehab-near-me", "/outpatient-rehab-near-me-nj"],
  ["/outpatient-rehab-near-me-no-insurance-nj", "/outpatient-rehab-near-me-nj"],
  ["/rehab-without-insurance-nj", "/outpatient-rehab-near-me-nj"],
  ["/detox-near-me", "/detox-near-me-south-jersey-nj"],
  ["/detox-near-me-medicaid-nj", "/detox-near-me-south-jersey-nj"],
  ["/medicaid-detox-nj", "/detox-near-me-south-jersey-nj"],
  ["/detox-centers-near-me-nj", "/detox-near-me-south-jersey-nj"],
  ["/addiction-treatment-near-me", "/addiction-treatment-near-me-nj"],
  ["/rehab-near-me", "/addiction-treatment-near-me-nj"],
  ["/rehab-near-me-nj", "/addiction-treatment-near-me-nj"],
  ["/drug-rehab-near-me", "/drug-rehab-near-me-south-jersey-nj"],
  ["/php-near-me", "/php-near-me-mental-health-nj"],
  ["/what-is-php-mental-health", "/php-near-me-mental-health-nj"],
  ["/iop-near-me", "/iop-near-me-after-work-nj"],
  ["/evening-iop-near-me", "/iop-near-me-after-work-nj"],
  ["/sober-living-near-me", "/sober-living-near-me-south-jersey-nj"],
  ["/sober-living-nj", "/sober-living-near-me-south-jersey-nj"],
  ["/suboxone-doctor-that-takes-insurance-nj", "/suboxone-doctor-near-me-insurance-nj"],
  ["/camden-county-addiction-treatment", "/addiction-treatment-camden-county-nj"],
  ["/addiction-treatment-camden-county", "/addiction-treatment-camden-county-nj"],
  ["/virtual-iop", "/virtual-iop-new-jersey"],
  ["/telehealth-addiction-treatment", "/virtual-iop-new-jersey"],
  ["/telehealth", "/virtual-iop-new-jersey"],
  ["/suboxone-doctor", "/suboxone-doctor-cherry-hill-nj"],
  ["/suboxone-doctor-near-me", "/suboxone-doctor-cherry-hill-nj"],
  ["/sublocade", "/sublocade-doctor-nj"],
  ["/sublocade-doctor-near-me", "/sublocade-doctor-nj"],
  ["/recovery-housing", "/recovery-housing-nj"],
  ["/sober-living-cherry-hill", "/recovery-housing-nj"],
  ["/contact-us", "/contact"],
  ["/find-drug-addiction-treatment-near-me", "/drug-rehab-near-me-south-jersey-nj"],
  ["/blog", "/addiction-resources-new-jersey"],
  ["/terms", "/privacy-policy"],
];
